import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { COMPANY, SERVICES, CITIES } from "@/data/content";
import { LogoWordmarkInverse } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#0C2749] text-white" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="mb-6">
              <LogoWordmarkInverse markSize={40} withSlogan />
            </div>
            <p className="text-white/70 leading-relaxed text-sm max-w-md">
              Premium Rohbau für anspruchsvolle Bauherren, Architekten und Bauträger in {COMPANY.region}. Termintreue, Festpreisgarantie und über zwei Jahrzehnte Erfahrung.
            </p>
            <div className="mt-6 space-y-3 text-sm">
              <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center gap-3 hover:text-white text-white/80" data-testid="footer-phone">
                <Phone className="w-4 h-4" /> {COMPANY.phone}
              </a>
              <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-white text-white/80" data-testid="footer-email">
                <Mail className="w-4 h-4" /> {COMPANY.email}
              </a>
              <p className="flex items-center gap-3 text-white/80"><MapPin className="w-4 h-4" /> {COMPANY.address}</p>
              <p className="flex items-center gap-3 text-white/80"><Clock className="w-4 h-4" /> {COMPANY.hours}</p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#2C80C8] mb-4">Leistungen</p>
            <ul className="space-y-2 text-sm">
              {SERVICES.slice(0, 8).map((s) => (
                <li key={s.slug}>
                  <Link to={`/leistungen/${s.slug}`} className="text-white/70 hover:text-white transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#2C80C8] mb-4">Standorte</p>
            <ul className="space-y-2 text-sm">
              {CITIES.map((c) => (
                <li key={c.slug}>
                  <Link to={`/standort/${c.slug}`} className="text-white/70 hover:text-white transition-colors">
                    Rohbau {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-[#2C80C8] mb-4">Unternehmen</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/referenzen" className="text-white/70 hover:text-white">Referenzen</Link></li>
              <li><Link to="/kontakt" className="text-white/70 hover:text-white">Kontakt</Link></li>
              <li><Link to="/preisrechner" className="text-white/70 hover:text-white">Preisrechner</Link></li>
              <li><Link to="/impressum" className="text-white/70 hover:text-white">Impressum</Link></li>
              <li><Link to="/datenschutz" className="text-white/70 hover:text-white">Datenschutz</Link></li>
              <li><Link to="/admin" className="text-white/40 hover:text-white text-xs">Admin</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} {COMPANY.name}. Alle Rechte vorbehalten.</p>
          <p className="text-xs text-white/50">Made for Bauherren, Architekten & Bauträger in NRW.</p>
        </div>
      </div>
    </footer>
  );
}
